import React, {useEffect, useRef} from 'react';
import {Tag, Popup, DynamicContainer, DurationPicker, Toggle, FormField} from 'components';
import {useSelector, useAsyncAction, useFormikContext, wait} from 'helpers';
import {times} from 'store/activities';
import {set, defaultSetting} from 'store/settings';

export function Reminder() {
  const container = useRef();
  const {values, setFieldValue} = useFormikContext();
  const hasTime = times(values).length > 0;
  const defaultInterval = useSelector(defaultSetting('reminderInterval', 15));

  const enable = () => {
    setFieldValue('reminder', 1);
    setFieldValue('reminderInterval', defaultInterval);
    requestAnimationFrame(() => {
      container.current.querySelector('input').focus();
    });
  };

  useEffect(() => {
    if (values.reminderInterval === null) {
      setFieldValue('reminder', 0);
      setFieldValue('reminderInterval', 0);
    }
  }, [values.reminderInterval]);

  useEffect(() => {
    if (!hasTime) {
      setFieldValue('reminder', 0);
      setFieldValue('reminderInterval', 0);
    }
  }, [hasTime]);

  return (
    <DynamicContainer>
      {hasTime &&
        <div style={{paddingTop: '1em'}} ref={container}>
          {values.reminder
            ? <DurationPicker name="reminderInterval" label="Reminder" placeholder="Set Alert.." Suffix={Suffix} allowZero allowAllDay={false} Suggestions={Suggestions} />
            : <FormField value label="Reminder">
              <Toggle setValue={enable} />
            </FormField>
          }
        </div>
      }
    </DynamicContainer>
  );
}

function Suffix({value, className}) {
  const defaultInterval = useSelector(defaultSetting('reminderInterval', 15));
  const {values} = useFormikContext();
  return (
    <span className={className}>
      {value !== 'on time' && 'before'}
      {' '}
      {defaultInterval !== values.reminderInterval &&
        <SetAsDefaultButton />
      }
    </span>
  );
}

const SetAsDefaultButton = () => {
  const {values} = useFormikContext();
  const confirm = async (event) => {
    window.document.activeElement.blur();
    await wait();
    set({
      module: 'defaults',
      key: 'reminderInterval',
      value: values.reminderInterval
    });
  };
  return (
    <Tag icon="check" aria-controls="edit" {...useAsyncAction(confirm)}>
      set as default
    </Tag>
  );
};

function Suggestions({value, setValue, parse, popup}) {
  const select = value => {
    setValue(value);
    popup.close();
  };
  return (
    <Popup.Menu>
      <Popup.Menu.Item snow pressed={parse({value}) === 0} onClick={() => select(0)}>On time</Popup.Menu.Item>
      <Popup.Menu.Item snow pressed={parse({value}) === 5} onClick={() => select(5)}>5 minutes</Popup.Menu.Item>
      <Popup.Menu.Item snow pressed={parse({value}) === 10} onClick={() => select(10)}>10 minutes</Popup.Menu.Item>
      <Popup.Menu.Item snow pressed={parse({value}) === 15} onClick={() => select(15)}>15 minutes</Popup.Menu.Item>
      <Popup.Menu.Item snow pressed={parse({value}) === 30} onClick={() => select(30)}>30 minutes</Popup.Menu.Item>
      <Popup.Menu.Item snow pressed={parse({value}) === 60} onClick={() => select(60)}>1 hour</Popup.Menu.Item>
      <Popup.Menu.Item snow pressed={parse({value}) === 60 * 2} onClick={() => select(60 * 2)}>2 hours</Popup.Menu.Item>
    </Popup.Menu>
  );
}
